import React, { createContext, useContext, useEffect, useState } from "react";

const AppContext = createContext(null);

export const ROLES = [
  { id: "admin", name: "Admin", desk: "Administration" },
  { id: "trader", name: "Trader", desk: "Trading Desk" },
  { id: "ops", name: "Operations", desk: "Operations / Logistics" },
  { id: "risk", name: "Risk / Finance", desk: "Risk & Finance" },
  { id: "accounts", name: "Accounts", desk: "Accounts" },
  { id: "management", name: "Management", desk: "Management (View-only)" },
];

// which nav module ids each role can access
export const ROLE_ACCESS = {
  admin: ["dashboard", "deals", "contracts", "linking", "vessels", "positions", "finance", "invoices", "fundflow", "counterparties", "accounting", "masters"],
  trader: ["dashboard", "deals", "contracts", "linking", "vessels", "positions"],
  ops: ["dashboard", "vessels", "contracts", "linking", "deals"],
  risk: ["dashboard", "positions", "finance", "fundflow", "counterparties", "vessels"],
  accounts: ["dashboard", "accounting", "finance", "invoices", "fundflow", "counterparties"],
  management: ["dashboard", "deals", "positions", "finance", "invoices", "fundflow", "vessels", "accounting"],
};

export function AppProvider({ children }) {
  const [role, setRole] = useState(() => localStorage.getItem("erp_role") || "admin");
  const [theme, setTheme] = useState(() => localStorage.getItem("erp_theme") || "light");
  const [entity, setEntity] = useState(() => localStorage.getItem("erp_entity") || "all");

  useEffect(() => {
    localStorage.setItem("erp_role", role);
  }, [role]);
  useEffect(() => {
    localStorage.setItem("erp_entity", entity);
  }, [entity]);
  useEffect(() => {
    localStorage.setItem("erp_theme", theme);
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  const can = (moduleId) => (ROLE_ACCESS[role] || []).includes(moduleId);

  return (
    <AppContext.Provider value={{ role, setRole, theme, setTheme, entity, setEntity, can }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
